
type GlobalConfigProps = {
    apiBaseUrl: string;
    cmsBaseUrl: string;
    baseAppPath: string;
    staticBaseUrl: string;
}
declare global {
    interface Window {
        mgpVadCollectifConfig: GlobalConfigProps;
    }
}

export const baseAppPath =  window.mgpVadCollectifConfig?.baseAppPath ?  window.mgpVadCollectifConfig.baseAppPath: "/contrat-collectif";
export const baseRetiredAppPath = "/retired-collectif";

export const apiAuthBaseUrl =  process.env.REACT_APP_API_AUTH_BASE_URL;
export const apiNotificationBaseUrl =  process.env.REACT_APP_API_NOTIFICATION_BASE_URL;
export const cmsBaseUrl = process.env.REACT_APP_CMS_BASE_URL;


export const RECAPTCHA_KEY = process.env.REACT_APP_RECAPTCHA_KEY;

export const uploadDocBaseUrl = process.env.REACT_APP_UPLOAD_DOC_BASE_URL;
export const dqeBaseUrl = "https://prod2.dqe-software.com";

export const staticBaseUrl = process.env.REACT_APP_RESSOURCE_BASE_URL;

export const grcAppBaseUrl = process.env.REACT_APP_GRC_APP_URL;

